
import { Monitor, Zap } from 'lucide-react';
import ResponsiveTestComponent from '../components/responsive-test';
import ToggleDemo from '../components/filterEffects';

export default function Home() {
return (
    <div className="py-10 px-4 md:px-20 max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <h1 className="lg:text-5xl text-2xl font-bold mb-4 text-color-slate-900 dark:text-color-white">
        Built for the modern web with Unicss.
        </h1>
        <p className="text-lg text-color-gray-600 max-w-4xl mx-auto dark:text-color-gray-300">
        Unicss provides a thoughtfully designed set of UI utilities that work seamlessly together, making your developer experience smooth and productive.
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-columns-1 xl:grid-columns-2 gap-12 mb-12">
        {/* Responsive Design */}
        <div className="col-span-2 bg-color-white rounded-2xl p-8 shadow-xs border border-color-gray-200 dark:bg-color-gray-900 dark:border-color-gray-700">
        <div className="flex items-center mb-6">
          <div className="w-12 h-12 bg-color-gray-100 rounded-lg flex items-center justify-center mr-4 dark:bg-color-gray-700">
            <Monitor className="w-6 h-6 text-color-gray-600 dark:text-color-gray-200" />
          </div>
          <div>
            <h3 className="text-xl font-semibold">Responsive design</h3>
            <p className="text-color-gray-600 text-sm dark:text-color-gray-400">Unicss makes it easy to build responsive layouts that look great on any device, so your site always feels modern and accessible.</p>
          </div>
        </div>
        
        {/* Property listing mockup */}
        <ResponsiveTestComponent/>
        </div>
        <ToggleDemo />
      </div>
      {/* Third Row */}
      <div className="grid grid-columns-1 xl:grid-columns-2 gap-8">
        {/* Transitions and Animations */}
        <div className="xl:col-span-2 bg-color-white rounded-2xl p-8 shadow-xs border border-color-gray-200 dark:bg-color-gray-900 dark:border-color-gray-700">
        <div className="flex mb-6">
          <div className="w-12 h-12 shrink-0 bg-color-gray-100 rounded-lg flex items-center justify-center mr-4 dark:bg-color-gray-700">
            <Zap className="lucide lucide-monitor w-6 h-6 text-color-gray-600 dark:text-color-gray-200" />
          </div>
          <div>
            <h3 className="text-xl font-semibold">Transitions and animations</h3>
            <p className="text-color-gray-600 text-sm dark:text-color-gray-400">Bring your Unicss-powered site to life with smooth transitions and animations, all with simple utility classes.</p>
          </div>
        </div>
        
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <span className="text-sm text-color-gray-600 dark:text-color-gray-400">ease-linear</span>
            <div className="w-8 h-8 bg-color-blue-400 duration-600 rounded-lg animate-translate-linear"></div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-color-gray-600 dark:text-color-gray-400">ease-out</span>
            <div className="w-8 h-8 bg-color-purple-400 duration-600 rounded-lg animate-translate-ease-out"></div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-color-gray-600 dark:text-color-gray-400">ease-in-out</span>
            <div className="w-8 h-8 bg-color-pink-400 duration-600 rounded-lg animate-translate-ease-in-out"></div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-color-gray-600 dark:text-color-gray-400">ease-in</span>
            <div className="w-8 h-8 bg-color-blue-500 duration-600 rounded-lg animate-translate-ease-in"></div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}